interface RequestOptions {
  method?: Request["method"];
  credentials?: Request["credentials"];
  responseType?: XMLHttpRequestResponseType;
  headers?: Headers;
  body?: BodyInit;
}

export type ProgressCallback = (evt: ProgressEvent) => void;

export function futch(
  url: string,
  options: RequestOptions = {},
  progressCallback: ProgressCallback = undefined,
  requestStartedCallback?: (XMLHttpRequest) => void,
): Promise<any> {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();

    request.open(options.method || "GET", url);

    if (Object.prototype.hasOwnProperty.call(options, "responseType")) {
      request.responseType = options.responseType || "";
    }

    for (const header in options.headers || {}) {
      if (options.headers && Object.prototype.hasOwnProperty.call(options.headers, header)) {
        request.setRequestHeader(header, options.headers[header]);
      }
    }

    request.addEventListener("load", () => {
      if (request.status === 200) {
        resolve(request.response);
      } else {
        if (import.meta.env.DEV) {
          // DO NOT DELETE, see SEL9-532
          // log the error code in console for dev, but do not show it in the reject
          // because it will pop up in a notification
          console.error(`${request.status} : ${request.statusText}`);
        }
        reject(new Error(`${request.responseText}`));
      }
    });

    request.addEventListener("error", () => reject(new Error("There was a network error.")));

    if (request.upload && progressCallback) {
      // => event.loaded / event.total * 100;
      // => event.lengthComputable
      request.upload.addEventListener("progress", progressCallback);
    }

    request.send(options.body);

    if (requestStartedCallback) {
      requestStartedCallback(request); // make it possible to abort the request
    }
  });
}
